import {
  WhiteLabelCompany,
  whiteLabelCompanies,
} from "@providers/white-label-provider";
import deTranslationsCompany1 from "@translations/locales/de/company-1.json";
import deTranslationsCompany2 from "@translations/locales/de/company-2.json";
import deTranslationsDefault from "@translations/locales/de/default.json";
import enTranslationsCompany1 from "@translations/locales/en/company-1.json";
import enTranslationsCompany2 from "@translations/locales/en/company-2.json";
import enTranslationsDefault from "@translations/locales/en/default.json";
import i18n, { ResourceKey } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

type SupportedLanguage = "en" | "de";

type TranslationResources = {
  [Lang in SupportedLanguage]: Record<WhiteLabelCompany, ResourceKey>;
};

const resources: TranslationResources = {
  en: {
    default: enTranslationsDefault,
    "company-1": enTranslationsCompany1,
    "company-2": enTranslationsCompany2,
  },
  de: {
    default: deTranslationsDefault,
    "company-1": deTranslationsCompany1,
    "company-2": deTranslationsCompany2,
  },
};

const fallbackLng: SupportedLanguage = "en";
const fallbackNS: WhiteLabelCompany = "default";

i18n.use(LanguageDetector).use(initReactI18next).init({
  fallbackLng,
  ns: whiteLabelCompanies,
  fallbackNS,
  resources,
});

export default i18n;
